export const statisticsWrapper = {
  background: "#0F054C",
  color: "#ffffff",
  padding: "6rem 0 4rem",
};
